import { loadedStatus } from '@/lib/contexts/auth';

/**
 * Block request dispatch until clerk finishes loading, polling on a short timeout so
 * the UI stays responsive while waiting.
 *
 * Must NOT use requestAnimationFrame here: rAF never fires while document.hidden is
 * true, so an occluded or unfocused window (embedded OAuth popups especially) would
 * queue every request forever and the OAuth authorize flow would never reach the
 * provider.
 */
const nonBlockingWaitToBeLoaded = () =>
  new Promise((resolve) => {
    const check = () => {
      if (loadedStatus.getIsLoaded() === false) {
        setTimeout(check, 50);
      } else {
        resolve();
      }
    };
    check();
  });

export default nonBlockingWaitToBeLoaded;
